@let formMode = editModel.state.roleFormMode();

<p-dialog
  class="dialog-primary dialog-content-flex border-top w1400 f-d-col"
  [modal]="true"
  [visible]="formMode !== undefined"
  (visibleChange)="editModel.resetForm()"
>
  <ng-template pTemplate="header">
    <div class="flex--col gap-4">
      <div class="text-18 fw-600 color-gray-900">
        @switch (formMode) {
          @case (TYPES.RoleFormMode.Add) {
            {{ 'roles.dialogs.add.summary' | translate }}
          }
          @case (TYPES.RoleFormMode.Edit) {
            {{ 'roles.dialogs.edit.summary' | translate }}
          }
          @case (TYPES.RoleFormMode.View) {
            {{ editModel.formState.value().name ?? '' }}
          }
        }
      </div>
      @if (formMode !== TYPES.RoleFormMode.View) {
        <div class="text-14 fw-400 color-gray-500">
          {{ 'roles.dialogs.add.description' | translate }}
        </div>
      }
    </div>
  </ng-template>

  <div class="content form flex--col gap-24">
    <app-role-form></app-role-form>
  </div>

  <div class="footer border-top">
    <div class="actions flex gap-12">
      @let isFormValid = editModel.state.isFormValid();
      @let isSaving = editModel.state.isSaving();

      <p-button
        [severity]="'secondary'"
        class="h--40 text-14 fw-600 w50"
        (click)="editModel.resetForm()"
      >
        {{ 'button.cancel' | translate }}
      </p-button>

      @switch (formMode) {
        @case ('add') {
          <p-button
            class="h--40 text-14 fw-600 w50"
            [disabled]="!isFormValid || isSaving"
            [loading]="isSaving"
            (click)="editModel.submitCreate()"
          >
            {{ 'button.add' | translate }}
          </p-button>
        }
        @case ('edit') {
          <p-button
            class="h--40 text-14 fw-600 w50"
            [disabled]="!isFormValid || isSaving"
            [loading]="isSaving"
            (click)="editModel.submitUpdate()"
          >
            {{ 'button.save' | translate }}
          </p-button>
        }
        @case ('view') {
          @let item = editModel.state.editedRoleData();
          <p-button
            class="h--40 text-14 fw-600 w50"
            [appCheckAccess]="{
              $and: [
                [TYPES.Resource.Role, TYPES.Action.Create],
                [TYPES.Resource.Role, TYPES.Action.Update],
              ],
            }"
            (click)="item ? duplicateClicked.emit(item) : undefined"
          >
            {{ 'button.duplicate' | translate }}
          </p-button>
        }
      }
    </div>
  </div>
</p-dialog>
